const accordionId = {
  PROFILE_DETAILS_ACCORDION: 'PROFILE_DETAILS_ACCORDION',
  CLIENT_TAG_ACCORDION: 'CLIENT_TAG_ACCORDION',
  SUBSCRIPTION_ACCORDION: 'SUBSCRIPTION_ACCORDION',
};

export {
  accordionId,
};
